( function( app ) {
  const COMPONENT = {

    // The mobile filter modal is moved to <body> by Magnific Popup while open,
    // so resolve the section through the modal's data attribute when needed.
    getSection: function( $el ) {
      const $section = $el.closest( '.testimonials-archive' );
      if ( $section.length ) {
        return $section;
      }

      const filtersId = $el.closest( '[data-testimonials-modal]' ).attr( 'data-testimonials-modal' );
      return $( `.testimonials-archive[data-filters-id="${ filtersId }"]` );
    },

    // The section plus its mobile modal, wherever the modal currently lives in the DOM.
    getScope: function( $section ) {
      return $section.add( `[data-testimonials-modal="${ $section.attr( 'data-filters-id' ) }"]` );
    },

    // Desktop and mobile render the same checkboxes, so dedupe by taxonomy + term.
    getCheckedTerms: function( $scope ) {
      const seen = new Set();
      const checked = [];

      $scope.find( '.testimonials-archive__filter-checkbox:checked' ).each( function() {
        const $checkbox = $( this );
        const key = `${ $checkbox.data( 'taxonomy' ) }:${ $checkbox.val() }`;

        if ( seen.has( key ) ) {
          return;
        }

        seen.add( key );
        checked.push( {
          taxonomy: $checkbox.data( 'taxonomy' ),
          id: $checkbox.val(),
          name: $checkbox.data( 'term-name' ),
          role: $checkbox.data( 'filter-role' ),
        } );
      } );

      return checked;
    },

    syncPills: function( $section ) {
      const $pillsWrap = $section.find( '[data-testimonials-active-filters]' );
      const checked = this.getCheckedTerms( this.getScope( $section ) );

      $pillsWrap.empty();

      if ( !checked.length ) {
        $pillsWrap.addClass( 'hidden' ).removeClass( 'flex' );
        return;
      }

      checked.forEach( function( term ) {
        const pill = $( '<button type="button" class="testimonials-archive__filter-pill"></button>' )
            .attr( 'data-taxonomy', term.taxonomy )
            .attr( 'data-term-id', term.id )
            .append( $( '<span></span>' ).text( term.name ) )
            .append( '<svg class="flex-none icon icon-cross-small size-3" aria-hidden="true"><use xlink:href="#icon-cross-small"></use></svg>' );

        $pillsWrap.append( pill );
      } );

      $pillsWrap.append( '<button type="button" class="testimonials-archive__clear-filters">Clear all</button>' );
      $pillsWrap.addClass( 'flex' ).removeClass( 'hidden' );
    },

    updateSubcategories: function( $section ) {
      const childrenMap = $section.data( 'category-children' ) || {};
      const $scope = this.getScope( $section );
      const $subcategoryGroups = $scope.find( '[data-subcategory-group]' );

      let children = [];
      this.getCheckedTerms( $scope ).forEach( function( term ) {
        if ( term.role === 'category' && childrenMap[term.id] ) {
          children = children.concat( childrenMap[term.id] );
        }
      } );

      if ( !children.length ) {
        $subcategoryGroups.find( '.testimonials-archive__filter-checkbox' ).prop( 'checked', false );
        $subcategoryGroups.find( '[data-subcategory-panel]' ).empty();
        $subcategoryGroups.addClass( 'hidden' );
        return;
      }

      $subcategoryGroups.each( function() {
        const $panel = $( this ).find( '[data-subcategory-panel]' );
        const previouslyChecked = new Set();

        $panel.find( '.testimonials-archive__filter-checkbox:checked' ).each( function() {
          previouslyChecked.add( String( $( this ).val() ) );
        } );

        $panel.empty();

        children.forEach( function( child ) {
          const $label = $( '<label class="testimonials-archive__checkbox"></label>' );
          const $input = $( '<input type="checkbox" class="testimonials-archive__filter-checkbox">' )
              .attr( 'data-taxonomy', 'll_testimonial_category' )
              .attr( 'data-filter-role', 'subcategory' )
              .attr( 'data-term-name', child.name )
              .val( child.id )
              .prop( 'checked', previouslyChecked.has( String( child.id ) ) );

          $label.append( $input ).append( $( '<span></span>' ).text( child.name ) );
          $panel.append( $label );
        } );
      } );

      $subcategoryGroups.removeClass( 'hidden' );
    },

    scrollToTop: function( $section ) {
      const el = $section.get( 0 );
      if ( el ) {
        el.scrollIntoView( {behavior: 'smooth', block: 'start'} );
      }
    },

    fetchResults: function( $section, page ) {
      const $results = $section.find( '[data-testimonials-results]' );
      const terms = {};

      this.scrollToTop( $section );

      this.getCheckedTerms( this.getScope( $section ) ).forEach( function( term ) {
        if ( !terms[term.taxonomy] ) {
          terms[term.taxonomy] = [];
        }
        terms[term.taxonomy].push( term.id );
      } );

      $section.addClass( 'is-loading' );

      $.ajax( {
        url: siteInfo.ajax_url,
        type: 'POST',
        data: {
          action: 'll_filter_testimonials',
          nonce: siteInfo.testimonials_nonce,
          terms: terms,
          page: page,
          card_theme: $section.data( 'card-theme' ),
        },
      } ).done( function( response ) {
        if ( response && response.success ) {
          $results.html( response.data.html );
        }
      } ).always( function() {
        $section.removeClass( 'is-loading' );
      } );
    },

    init: function() {
      const _this = this;

      $( document ).on( 'change', '.testimonials-archive__filter-checkbox', function() {
        const $checkbox = $( this );
        const $section = _this.getSection( $checkbox );

        // Mirror the state onto the matching checkbox in the other (desktop/mobile) filter set.
        _this.getScope( $section )
            .find( `.testimonials-archive__filter-checkbox[data-taxonomy="${ $checkbox.data( 'taxonomy' ) }"][value="${ $checkbox.val() }"]` )
            .not( $checkbox )
            .prop( 'checked', $checkbox.prop( 'checked' ) );

        if ( $checkbox.data( 'filter-role' ) === 'category' ) {
          _this.updateSubcategories( $section );
        }

        _this.syncPills( $section );
        _this.fetchResults( $section, 1 );
      } );

      $( document ).on( 'click', '.testimonials-archive [data-page]', function( e ) {
        e.preventDefault();
        const $button = $( this );
        if ( $button.is( '[disabled]' ) ) {
          return;
        }
        const $section = $button.closest( '.testimonials-archive' );
        _this.fetchResults( $section, $button.data( 'page' ) );
      } );

      $( document ).on( 'click', '.testimonials-archive__filter-pill', function() {
        const $pill = $( this );
        const $section = $pill.closest( '.testimonials-archive' );
        const $checkbox = _this.getScope( $section )
            .find( `.testimonials-archive__filter-checkbox[data-taxonomy="${ $pill.data( 'taxonomy' ) }"][value="${ $pill.data( 'term-id' ) }"]` )
            .prop( 'checked', false );

        if ( $checkbox.data( 'filter-role' ) === 'category' ) {
          _this.updateSubcategories( $section );
        }

        _this.syncPills( $section );
        _this.fetchResults( $section, 1 );
      } );

      $( document ).on( 'click', '.testimonials-archive__clear-filters', function() {
        const $section = $( this ).closest( '.testimonials-archive' );
        _this.getScope( $section ).find( '.testimonials-archive__filter-checkbox:checked' ).prop( 'checked', false );

        _this.updateSubcategories( $section );
        _this.syncPills( $section );
        _this.fetchResults( $section, 1 );
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'testimonials-archive', COMPONENT );
} )( app );
